<template>
  <div v-if="data">
    <div
      v-for="(previousCreditor, index) in data"
      :key="previousCreditor + index + Math.random()"
    >
      <div v-if="previousCreditor" class="form-base__title preview break">
        {{ `Кредитор №${index + 1}` }}
      </div>

      <div v-if="previousCreditor" class="row-box mb-5">
        <Person :data="previousCreditor" v-if="previousCreditor.person" />
        <Organization
          :data="previousCreditor"
          v-if="previousCreditor.organization"
        />
        <ForeignOrganization
          :data="previousCreditor"
          v-if="previousCreditor.foreignOrganization"
        />

        <div class="row-box" v-if="previousCreditor.changeReason">
          <WrapperField
            :data="createDataField({fieldName: 'changeReason', fieldValue: previousCreditor.changeReason, fieldGroup: 'previousCreditors'})"
          ></WrapperField>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import Person from '@/components/elements/statement/FullStatementView/elements/Person';
import Organization from '@/components/elements/statement/FullStatementView/elements/Organization';
import ForeignOrganization from '@/components/elements/statement/FullStatementView/elements/ForeignOrganization';

export default {
  name: 'Step2',
  components: {
    WrapperField,
    ForeignOrganization,
    Organization,
    Person,
  },
  props: ['data'],
  data: () => ({
    createDataField,
  }),
};
</script>
